export default (props: { fill?: string; id?: string; size?: number }) => (
	<svg
		id={props.id}
		width={props.size ?? 24}
		height={props.size ?? 24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#dab9ty5y1a)">
			<path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" fill={props.fill || "#969392"} />
		</g>
		<defs>
			<clipPath id="dab9ty5y1a">
				<path fill="#fff" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);
